import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';
import { transliterate } from '~/src/helpers/transliterate.helper';

export const onSendPersonContactsAnalytics = (
    name: string,
    eventCategory: WebAnalyticsEventCategoryEnum,
    error?: string,
) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.formAdd,
            eventLabel: name,
            eventContent: null,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: eventCategory,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: null,
            ...(error ? { eventContext: transliterate(error) } : {}),
        }),
    );
};
